import { Components, Theme } from '@mui/material/styles';

import * as Colors from 'src/theme/colors';

const MuiCssBaseline: Components<Theme>['MuiCssBaseline'] = {
  styleOverrides: {
    body: {
      margin: '8px 0 0',
      backgroundColor: Colors.white,
      lineHeight: 1.2,
    },
  },
};

export default MuiCssBaseline;
